// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__39iw6","row":"Node_row__1v99l","label":"Node_label__8jRQE","footer":"Node_footer__i4ANO"};